import { Controller } from "@hotwired/stimulus"
import axios from 'axios'

export default class extends Controller {
  static values = {
    eventName: String,
    location: String,
    path: String
  }

  connect() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken
    axios.post('/note/events', {
      event_name: this.eventNameValue,
      location: this.locationValue,
      path: this.pathValue
    })
  }
}
